import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import PrivateRoute from './components/PrivateRoute';
import LoginPage from './components/LoginPage';
import Sidebar from './components/Sidebar';
import Homepage from './pages/Homepage';
import Events from './pages/Events';
import Clients from './pages/Clients';
import Locations from './pages/Locations';
import SingleTravel from './pages/SingleTravel';
import Matching from './pages/Matching';
import Profile from './pages/Profile';
import SendMessages from './pages/SendMessages';
import Advertisements from './pages/Advertisements';
import UserManagement from './pages/UserManagement';
import Team from './pages/Team';
import Contabilita from './pages/Contabilita';
import AgenziaAmore from './pages/AgenziaAmore';
import DatingCoach from './pages/DatingCoach';
import ConsulenteDImmagine from './pages/ConsulenteDImmagine';
import HeartLink from './pages/HeartLink';
import MessaggeriaPage from './pages/MessaggeriaPage';
import Board from './pages/Board';
import CorsiPerSingle from './pages/CorsiPerSingle';
import Tavoli from './pages/Tavoli';
import Messaggi from './pages/Messaggi';
import Affiliati from './pages/Affiliati';
import LavoraConNoi from './pages/LavoraConNoi';
import Candidature from './pages/Candidature';
import SerateVip from './pages/SerateVip';
import SerateScambi from './pages/SerateScambi';

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  return (
    <LanguageProvider>
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/heartlink" element={<HeartLink />} />
          <Route path="/affiliati" element={<Affiliati />} />
          <Route path="/lavora-con-noi" element={<LavoraConNoi />} />
          <Route path="/messaggeria" element={<MessaggeriaPage />} />
          <Route
            path="/dashboard/*"
            element={
              <PrivateRoute>
                <div className="flex h-screen bg-gray-50">
                  <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
                  <div className="flex-1 overflow-auto">
                    <button
                      onClick={() => setIsSidebarOpen(true)}
                      className="lg:hidden fixed top-4 left-4 z-30 p-2 bg-white rounded-lg shadow-lg hover:bg-gray-50 transition-colors"
                      aria-label="Apri menu"
                    >
                      <Menu className="h-6 w-6 text-gray-700" />
                    </button>
                    <Routes>
                      <Route path="/" element={<Homepage />} />
                      <Route path="/events" element={<Events />} />
                      <Route
                        path="/clients"
                        element={
                          <PrivateRoute menuItem="Clienti">
                            <Clients />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/locations"
                        element={
                          <PrivateRoute menuItem="Location">
                            <Locations />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/matching"
                        element={
                          <PrivateRoute menuItem="Matching">
                            <Matching />
                          </PrivateRoute>
                        }
                      />
                      <Route path="/single-travel" element={<SingleTravel />} />
                      <Route
                        path="/send-messages"
                        element={
                          <PrivateRoute menuItem="Invia Messaggi">
                            <SendMessages />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/advertisements"
                        element={
                          <PrivateRoute menuItem="Pubblicità">
                            <Advertisements />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/user-management"
                        element={
                          <PrivateRoute menuItem="Gestione Staff">
                            <UserManagement />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/team"
                        element={
                          <PrivateRoute menuItem="Team">
                            <Team />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/contabilita"
                        element={
                          <PrivateRoute menuItem="Contabilità">
                            <Contabilita />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/agenzia-amore"
                        element={
                          <PrivateRoute menuItem="Agenzia Amore">
                            <AgenziaAmore />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/dating-coach"
                        element={
                          <PrivateRoute menuItem="Dating Coach">
                            <DatingCoach />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/consulente-immagine"
                        element={
                          <PrivateRoute menuItem="Consulente d'Immagine">
                            <ConsulenteDImmagine />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/board"
                        element={
                          <PrivateRoute menuItem="Bacheca">
                            <Board />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/corsi-per-single"
                        element={
                          <PrivateRoute menuItem="Corsi per Single">
                            <CorsiPerSingle />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/messaggeria/tavoli"
                        element={
                          <PrivateRoute menuItem="Tavoli">
                            <Tavoli />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/messaggeria/messaggi"
                        element={
                          <PrivateRoute menuItem="Messaggi">
                            <Messaggi />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/candidature"
                        element={
                          <PrivateRoute menuItem="Candidature">
                            <Candidature />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/serate-vip"
                        element={
                          <PrivateRoute menuItem="Serate VIP">
                            <SerateVip />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/serate-scambi"
                        element={
                          <PrivateRoute menuItem="Serate Scambi">
                            <SerateScambi />
                          </PrivateRoute>
                        }
                      />
                      <Route path="/profile" element={<Profile />} />
                      <Route path="*" element={<Navigate to="/dashboard" />} />
                    </Routes>
                  </div>
                </div>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;